import { GameDocument } from '../../../types/game-document';

/**
 * Get inventory by Id from game document local storage.
 * @param gameDocument - The Game Document as datasource
 * @constructor
 */
export const GetInventoryById = (
  gameDocument: GameDocument | undefined,
  id: string
) => {
  return gameDocument?.assets?.items?.find((x) => x.id === id);
};
